import { ChangeDetectorRef,
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output, inject, DestroyRef ,
  ChangeDetectionStrategy,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { GtwSnackbarService } from '../../../shared/_services/gtw-snackbar.service';
import { Fir8865SchedulePService } from './fir-8865-schedule-p.service';
import * as _ from 'lodash-es';
import { GlobalService } from '../../../global/services/global.service';
import { WorkspaceService } from '../../../workspace/workspace.service';
import { AppService } from '../../../app.service';
import {
  buildHeaderDataShell,
  extractObject,
  generalConfigFromGlobal,
  hydratedGlobalParams,
  normalizeFilterParams,
  rowPayloadFromActiveScreen,
} from '../../../shared/workspace-element-context';
import { parseAsLocalDate } from '../../../shared/_utils';

import { safeJsonInput } from '../../../shared/_utils/safe-json-input';
@Component({
    selector: 'gtw-fir-8865-schedule-p',
    templateUrl: './fir-8865-schedule-p.component.html',
    styleUrls: ['./fir-8865-schedule-p.component.scss'],
    standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class Fir8865SchedulePComponent implements OnInit, OnDestroy {
  private readonly destroyRef = inject(DestroyRef);

  @Output('request-grid-update') requestGridUpdate = new EventEmitter<any>();

  // Modal properties
  modalTitle = 'Schedule P';
  minimise = false;
  crudLoading = false;

  // Tab management
  tabs = [
    { id: 0, name: '8865' },
    { id: 1, name: 'Add new Acquisition' },
    { id: 2, name: 'Add new Disposition' },
    { id: 3, name: 'Add new Change in Proportional Interest' },
    { id: 4, name: 'Add new Supplemental Information' }
  ];
  activeTab = 0;
  selectedTabName = '8865';

  // Data from AngularJS
  rowData: any = {};
  filterParams: any = {};
  globalService: any = {};
  GENERAL_CONFIG: any = {};
  baseURLs: any = {};
  USER_SETTINGS: any = {};

  // Lookup data
  countries: any[] = [];
  states: any[] = [];

  // Schedule P Details
  schedulePDetails: any[] = [];

  // Tab 1 (8865) - Data Arrays
  acquistionObj: any[] = [];
  dispositionObj: any[] = [];
  proportionalInterestObj: any[] = [];
  supplementalObj: any[] = [];

  // Visibility flags
  isStockAquistionDataPresent = false;
  isStockDispositionDataPresent = false;
  isProportionalInterestPresent = false;
  isSupplementalInformationPresent = false;

  // Collapse states
  stockAquistionCollapsed = true;
  stockDispositionCollapsed = true;
  ProportionalInterestPresentCollapsed = true;
  SupplementalInformationPresentcollapsed = true;

  // Tab C (Acquisition) Data
  selectedTabCData: any = {};
  selectedTabCDataCloned: any = {};

  // Tab D (Disposition) Data
  selectedTabDData: any = {};
  selectedTabDDataCloned: any = {};

  // Tab E (Proportional Interest) Data
  selectedTabEData: any = {};
  selectedTabEDataCloned: any = {};

  // Tab F (Supplemental) Data
  selectedTabFData: any = {};
  selectedTabFDataCloned: any = {};

  // Attribute Arrays
  stockAcquisitionAttrib: any[] = [];
  stockDispositionAttrib: any[] = [];
  stockProportionalAttrib: any[] = [];
  stocksupplementalAttrib: any[] = [];

  // Internal arrays
  acquistionArray: any[] = [];
  dispositionArray: any[] = [];
  proportionalInterestArray: any[] = [];
  supplementalArray: any[] = [];

  // Edit flag
  editFlag = false;

  // Validation flags
  date_flag_acquisition = false;
  date_range_acquisition = false;
  date_flag_disposition = false;
  date_range_disposition = false;
  date_flag_change = false;
  date_range_change = false;
  desc_of_change = false;
  
  // Percentage validation flags
  percent_before_acquisition_invalid = false;
  percent_after_acquisition_invalid = false;
  percent_before_disposition_invalid = false;
  percent_after_disposition_invalid = false;
  percent_before_change_invalid = false;
  percent_after_change_invalid = false;
  
  // Zip code validation flags
  zip_invalid_c = false;
  zip_invalid_d = false;

  // Loading state
  showFormLoader = false;

  // Initialization flags
  private isInitialized = false;
  private isLoading = false;

  /** Invalidates in-flight init HTTP when HO row changes (rapid grid navigation). */
  private contextEpoch = 0;
  /** Invalidates overlapping Schedule P detail loads (init + tab-0 refresh). */
  private detailsLoadSeq = 0;
  private lastCombinationKey: string | number | undefined;

  private readonly contextSubs = new Subscription();

  constructor(
    private schedulePService: Fir8865SchedulePService,
    private gtwSnackbarService: GtwSnackbarService,
    private cdr: ChangeDetectorRef,
    private gtwGlobal: GlobalService,
    private gtwWorkspace: WorkspaceService,
    private gtwApp: AppService
  ) {}

  ngOnInit(): void {
    this.resetAndTryInit();
    this.contextSubs.add(
      this.gtwWorkspace.setTabActive.subscribe(() => {
        this.resetAndTryInit();
      })
    );
    this.contextSubs.add(
      this.gtwGlobal.globalParamsChanged$.subscribe(() => {
        this.resetAndTryInit();
      })
    );
  }

  ngOnDestroy(): void {
    this.contextEpoch++;
    this.contextSubs.unsubscribe();
  }

  private applyWorkspaceContext(): void {
    const activeScreen = this.gtwWorkspace.workspaceFactory?.activeScreen || {};
    const shell = buildHeaderDataShell(this.gtwGlobal, this.gtwApp);
    const hydrated = hydratedGlobalParams(this.gtwGlobal, this.gtwWorkspace) || {};
    let fp = normalizeFilterParams(activeScreen);
    if (!Object.keys(fp).length) {
      fp = extractObject(hydrated);
    }
    this.filterParams = fp;
    const mergedGp = { ...extractObject(shell.globalParams), ...extractObject(hydrated) };
    this.globalService = {
      ...shell,
      globalParams: mergedGp,
      filterParams: fp,
      workspaceFactory: this.gtwWorkspace.workspaceFactory,
      getScenario: (ty: any) => this.gtwGlobal.getScenario(ty),
      getEIN: () => this.gtwGlobal.getEIN(),
      getTAXYEAR: () => this.gtwGlobal.getTAXYEAR(),
      getChartType: () => this.gtwGlobal.getChartType(),
      inputs: this.gtwGlobal.inputs,
      sso_id: this.gtwApp?.USER_SETTINGS?.user?.sso_id ?? '',
    };
    Object.assign(this.globalService, mergedGp);
    this.USER_SETTINGS = this.gtwApp?.USER_SETTINGS || {};
    const gc = generalConfigFromGlobal(this.gtwGlobal);
    this.GENERAL_CONFIG = { ...gc, base_url: gc.base_url || gc.api || '' };
    this.baseURLs = gc;
    const rawRow = rowPayloadFromActiveScreen(activeScreen);
    this.rowData = Array.isArray(rawRow)
      ? extractObject(rawRow[0]?.data ?? rawRow[0])
      : extractObject(rawRow);
  }

  private resetAndTryInit(): void {
    this.contextEpoch++;
    this.isInitialized = false;
    this.isLoading = false;
    this.applyWorkspaceContext();
    const key = this.rowData?.HO_COMBINATION_KEY;
    if (this.lastCombinationKey !== undefined && key !== this.lastCombinationKey) {
      this.contextEpoch++;
      this.detailsLoadSeq++;
      this.isInitialized = false;
      this.isLoading = false;
    }
    this.lastCombinationKey = key;
    this.tryInit();
    this.cdr.markForCheck();
  }

  private tryInit() {
    if (this.isInitialized || this.isLoading) return;
    
    // Check for base_url in different possible locations
    const baseUrl = this.GENERAL_CONFIG?.base_url || this.GENERAL_CONFIG?.api || '';
    
    if (this.rowData && Object.keys(this.rowData).length > 0 && baseUrl) {
      // Normalize base_url
      if (!this.GENERAL_CONFIG.base_url && this.GENERAL_CONFIG.api) {
        this.GENERAL_CONFIG.base_url = this.GENERAL_CONFIG.api;
      }
      
      this.isLoading = true;
      this.init();
    }
  }

  init() {
    try {
      const ctxSnap = this.contextEpoch;
      // Initialize default values for tab data
      this.selectedTabCData.NAME_OF_PERSON_OR_BUSINESS = 'B';
      this.selectedTabDData.NAME_OF_PERSON_OR_BUSINESS = 'B';

      // Load lookup data
      this.loadCountries(ctxSnap);
      this.loadStates(ctxSnap);
      
      // Load Schedule P details
      this.loadDetails();
      
      // Load attribute names
      this.setAttribute(ctxSnap);

      this.isInitialized = true;
    } catch (e) {
      console.error('Error in Fir8865ScheduleP init:', e);
      this.isLoading = false;
    }
  }

  loadCountries(ctxSnap: number) {
    const params = {
      tax_year: this.globalService.tax_year,
      jcd_key: this.globalService.jcd_key || 250
    };

    this.schedulePService.getCountriesFIR(
      this.GENERAL_CONFIG.base_url,
      params,
      this.globalService,
      this.filterParams
    ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (data: any) => {
        if (ctxSnap !== this.contextEpoch) {
          return;
        }
        if (data.callSuccess === '1') {
          this.countries = data.jsonObject;
          this.cdr.detectChanges();
        }
      },
      (error: any) => {
        console.error('Error loading countries:', error);
      }
    );
  }

  loadStates(ctxSnap: number) {
    const params = {
      tax_year: this.globalService.tax_year,
      jcd_key: this.globalService.jcd_key || 250
    };

    this.schedulePService.getStates(
      this.GENERAL_CONFIG.base_url,
      params,
      this.globalService,
      this.filterParams
    ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (data: any) => {
        if (ctxSnap !== this.contextEpoch) {
          return;
        }
        if (data.callSuccess === '1') {
          this.states = data.jsonObject;
          this.cdr.detectChanges();
        }
      },
      (error: any) => {
        console.error('Error loading states:', error);
      }
    );
  }

  loadDetails() {
    const dseq = ++this.detailsLoadSeq;
    this.showFormLoader = true;

    const params = {
      combination_key: this.rowData.HO_COMBINATION_KEY,
      irs_form_no: 'F8865'
    };

    this.schedulePService.loadSchedulePDetails(
      this.GENERAL_CONFIG.base_url,
      params,
      this.globalService,
      this.filterParams
    ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (data: any) => {
        if (dseq !== this.detailsLoadSeq) {
          return;
        }
        this.showFormLoader = false;
        this.isLoading = false;

        if (data.callSuccess === '1') {
          this.schedulePDetails = data.jsonObject;
          this.processSchedulePData();
          this.cdr.detectChanges();
        } else {
          this.gtwSnackbarService.openSnackBar(
            data.errorMessage || 'Error loading Schedule P details',
            'gtw-snackbar--red'
          );
        }
      },
      (error: any) => {
        if (dseq !== this.detailsLoadSeq) {
          return;
        }
        this.showFormLoader = false;
        this.isLoading = false;
        console.error('Error loading Schedule P details:', error);
        this.gtwSnackbarService.openSnackBar(
          'Error occurred while loading data. Please try again.',
          'gtw-snackbar--red'
        );
      }
    );
  }

  processSchedulePData() {
    
    if (!this.schedulePDetails || this.schedulePDetails.length === 0) {
      return;
    }

    // Process the raw data similar to AngularJS controller
    for (let i = 1; i < this.schedulePDetails.length; i++) {
      const originalObj = this.schedulePDetails[i];
      const tempString = originalObj.object_id || '';
      const tempValue = originalObj.attrib_value || '';

      this.schedulePDetails[i] = {
        i: originalObj,
        tax_year: tempString.split('~')[0],
        trans_type_key: tempString.split('~')[1],
        attrib_name: tempValue.split('~')[0],
        attrib_desc: tempValue.split('~')[3],
        line_attrib_key: tempValue.split('~')[1],
        trans_details_key: tempString.split('~')[3],
        occurrence: tempString.split('~')[4],
        VALUE: originalObj.VALUE,
        form_key: tempString.split('~')[6],
        line_no: originalObj.line_no
      };
    }

    
    // CRITICAL: Set LINE_NO on each entry based on attrib_name === 'LINE_NO' entries
    // This is from the original AngularJS code - lines 302-312
    let lineNo: string = '';
    for (let i = 1; i < this.schedulePDetails.length; i++) {
      const currentObj = this.schedulePDetails[i];
      if (currentObj.attrib_name === 'LINE_NO') {
        lineNo = currentObj.attrib_desc;
        continue;
      } else {
        this.schedulePDetails[i].LINE_NO = lineNo;
      }
    }
    
    // Process acquisition data (line_no = '1' or 1)
    this.processAcquisitionData();
    
    // Process disposition data (line_no = '2' or 2)
    this.processDispositionData();
    
    // Process proportional interest data (line_no = '3' or 3)
    this.processProportionalInterestData();
    
    // Process supplemental data (line_no = '4' or 4)
    this.processSupplementalData();
    
  }

  processAcquisitionData() {
    this.acquistionObj = [];
    // Use loose comparison (==) like original AngularJS to handle both string and number
    this.acquistionArray = _.filter(this.schedulePDetails, (o: any) => o.line_no == '1');

    if (this.acquistionArray.length > 0) {
      _.uniq(_.map(this.acquistionArray, 'occurrence')).forEach((p_occurrence: any) => {
        if (p_occurrence === '0') return;

        const occList = _.filter(this.acquistionArray, { occurrence: p_occurrence });
        const temp: any = {};

        occList.forEach((currentObj: any) => {
          if (!currentObj.trans_details_key || currentObj.trans_details_key === '0') return;

          temp.LINE_NO = 1;
          temp.occurrence = p_occurrence;
          temp.trans_details_key = currentObj.trans_details_key;

          if (currentObj.attrib_name === 'IDENTIFYING_NO') {
            if (currentObj.VALUE) {
              if (currentObj.VALUE === 'APPLD FOR' || currentObj.VALUE === 'FOREIGNUS') {
                temp.VALUE = currentObj.VALUE;
                temp.DISVALUE = null;
              } else {
                temp.DISVALUE = this.changeIdentifyingTexttoDashed(currentObj.VALUE);
                temp.VALUE = temp.DISVALUE;
                temp.DISVALUE = temp.DISVALUE ? temp.DISVALUE.replace('-', '') : null;
              }
            } else {
              temp.VALUE = null;
              temp.DISVALUE = null;
            }
            temp[currentObj.attrib_name] = currentObj.VALUE;
          } else {
            temp[currentObj.attrib_name] = currentObj.VALUE;
          }
        });

        if (temp.LINE_NO) {
          this.acquistionObj.push(temp);
        }
      });
    }

    this.isStockAquistionDataPresent = this.acquistionObj.length > 0;
  }

  processDispositionData() {
    this.dispositionObj = [];
    // Use loose comparison (==) like original AngularJS
    this.dispositionArray = _.filter(this.schedulePDetails, (o: any) => o.line_no == '2');

    if (this.dispositionArray.length > 0) {
      _.uniq(_.map(this.dispositionArray, 'occurrence')).forEach((p_occurrence: any) => {
        if (p_occurrence === '0') return;

        const occList = _.filter(this.dispositionArray, { occurrence: p_occurrence });
        const temp: any = {};

        occList.forEach((currentObj: any) => {
          if (!currentObj.trans_details_key || currentObj.trans_details_key === '0') return;

          temp.LINE_NO = 2;
          temp.occurrence = p_occurrence;
          temp.trans_details_key = currentObj.trans_details_key;

          if (currentObj.attrib_name === 'IDENTIFYING_NO') {
            if (currentObj.VALUE) {
              if (currentObj.VALUE === 'APPLD FOR' || currentObj.VALUE === 'FOREIGNUS') {
                temp.VALUE = currentObj.VALUE;
                temp.DISVALUE = null;
              } else {
                temp.DISVALUE = this.changeIdentifyingTexttoDashed(currentObj.VALUE);
                temp.VALUE = temp.DISVALUE;
                temp.DISVALUE = temp.DISVALUE ? temp.DISVALUE.replace('-', '') : null;
              }
            } else {
              temp.VALUE = null;
              temp.DISVALUE = null;
            }
            temp[currentObj.attrib_name] = currentObj.VALUE;
          } else {
            temp[currentObj.attrib_name] = currentObj.VALUE;
          }
        });

        this.dispositionObj.push(temp);
      });
    }

    this.isStockDispositionDataPresent = this.dispositionObj.length > 0;
  }

  processProportionalInterestData() {
    this.proportionalInterestObj = [];
    // Use loose comparison (==) like original AngularJS
    this.proportionalInterestArray = _.filter(this.schedulePDetails, (o: any) => o.line_no == '3');

    if (this.proportionalInterestArray.length > 0) {
      _.uniq(_.map(this.proportionalInterestArray, 'occurrence')).forEach((p_occurrence: any) => {
        if (p_occurrence === '0') return;

        const occList = _.filter(this.proportionalInterestArray, { occurrence: p_occurrence });
        const temp: any = {};

        occList.forEach((currentObj: any) => {
          if (!currentObj.trans_details_key || currentObj.trans_details_key === '0') return;

          temp.LINE_NO = 3;
          temp.occurrence = p_occurrence;
          temp.trans_details_key = currentObj.trans_details_key;
          temp[currentObj.attrib_name] = currentObj.VALUE;
        });

        this.proportionalInterestObj.push(temp);
      });
    }

    this.isProportionalInterestPresent = this.proportionalInterestObj.length > 0;
  }

  processSupplementalData() {
    this.supplementalObj = [];
    // Use loose comparison (==) like original AngularJS
    this.supplementalArray = _.filter(this.schedulePDetails, (o: any) => o.line_no == '4');

    if (this.supplementalArray.length > 0) {
      _.uniq(_.map(this.supplementalArray, 'occurrence')).forEach((p_occurrence: any) => {
        if (p_occurrence === '0') return;

        const occList = _.filter(this.supplementalArray, { occurrence: p_occurrence });
        const temp: any = {};

        occList.forEach((currentObj: any) => {
          if (!currentObj.trans_details_key || currentObj.trans_details_key === '0') return;

          temp.LINE_NO = 4;
          temp.occurrence = p_occurrence;
          temp.trans_details_key = currentObj.trans_details_key;
          temp[currentObj.attrib_name] = currentObj.VALUE;
        });

        this.supplementalObj.push(temp);
      });
    }

    // Use loose comparison (==) like original AngularJS - comparing LINE_NO property
    this.isSupplementalInformationPresent = this.schedulePDetails.filter(
      (entry: any) => entry.LINE_NO == '4' && entry.VALUE
    ).length > 0;
  }

  setAttribute(ctxSnap: number) {
    const params = {
      tax_year: this.globalService.tax_year,
      scenario: this.globalService.scenario,
      jcd_key: 250,
      irs_form_no: 'F8865'
    };

    this.schedulePService.loadAttributeNames(
      this.GENERAL_CONFIG.base_url,
      params,
      this.globalService,
      this.filterParams
    ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (res: any) => {
        if (ctxSnap !== this.contextEpoch) {
          return;
        }
        if (res.callSuccess === '1') {
          try {
            this.stockAcquisitionAttrib = safeJsonInput<any>(res.jsonObject[0].LINE1_ATTRIB, null, 'fir-8865-schedule-p.parse1');
            this.stockDispositionAttrib = safeJsonInput<any>(res.jsonObject[0].LINE2_ATTRIB, null, 'fir-8865-schedule-p.parse2');
            this.stockProportionalAttrib = safeJsonInput<any>(res.jsonObject[0].LINE3_ATTRIB, null, 'fir-8865-schedule-p.parse3');
            this.stocksupplementalAttrib = safeJsonInput<any>(res.jsonObject[0].LINE4_ATTRIB, null, 'fir-8865-schedule-p.parse4');
          } catch (parseErr) {
            console.error('Error parsing attribute names:', parseErr);
          }
        }
      },
      (error: any) => {
        console.error('Error loading attribute names:', error);
      }
    );
  }

  changeIdentifyingTexttoDashed(value: string): string {
    if (value && value.length > 2 && value.indexOf('-') === -1) {
      return value.substr(0, 2) + '-' + value.substr(2, value.length);
    }
    return value;
  }

  onTabChange(tabId: number) {
    this.activeTab = tabId;
    this.selectedTabName = this.tabs.find(t => t.id === tabId)?.name || '';
  }

  clearTabData(selectedTabIndex: number) {
    this.editFlag = false;
    this.date_flag_acquisition = false;
    this.date_range_acquisition = false;
    this.date_flag_disposition = false;
    this.date_range_disposition = false;
    this.date_flag_change = false;
    this.date_range_change = false;
    this.desc_of_change = false;
    
    // Reset percentage validation flags
    this.percent_before_acquisition_invalid = false;
    this.percent_after_acquisition_invalid = false;
    this.percent_before_disposition_invalid = false;
    this.percent_after_disposition_invalid = false;
    this.percent_before_change_invalid = false;
    this.percent_after_change_invalid = false;
    
    // Reset zip code validation flags
    this.zip_invalid_c = false;
    this.zip_invalid_d = false;

    if (selectedTabIndex === 0) {
      this.loadDetails();
    }

    if (selectedTabIndex === 1) {
      this.selectedTabCData = {};
      this.selectedTabCData.NAME_OF_PERSON_OR_BUSINESS = 'B';
      this.selectedTabCData.PERCENT_OF_INTEREST_BEFORE_ACQUISITION = null;
      this.selectedTabCData.PERCENT_OF_INTEREST_AFTER_ACQUISITION = null;
    }

    if (selectedTabIndex === 2) {
      this.selectedTabDData = {};
      this.selectedTabDData.NAME_OF_PERSON_OR_BUSINESS = 'B';
      this.selectedTabDData.PERCENT_OF_INTEREST_BEFORE_DISPOSITION = null;
      this.selectedTabDData.PERCENT_OF_INTEREST_AFTER_DISPOSITION = null;
    }

    if (selectedTabIndex === 3) {
      this.selectedTabEData = {};
      this.selectedTabEData.PERCENT_OF_INTEREST_BEFORE_CHANGE = null;
      this.selectedTabEData.PERCENT_OF_INTEREST_AFTER_CHANGE = null;
    }

    if (selectedTabIndex === 4) {
      this.selectedTabFData = {};
    }
  }

  editSchedule(item: any) {
    this.editFlag = true;

    const lineNo = item.LINE_NO.toString();

    switch (lineNo) {
      case '1':
        this.activeTab = 1;
        this.selectedTabName = 'Add new Acquisition';
        this.selectedTabCData = { ...item };

        // Convert date to YYYY-MM-DD string format for HTML date input
        // Handle various date formats that might come from the API
        const dateValue1 = item.DATE_OF_ACQUISITION;
        if (dateValue1 && dateValue1 !== '' && dateValue1 !== 'null') {
          let dateSet: Date;
          
          // Check if it's already in MM/dd/yyyy format
          if (typeof dateValue1 === 'string' && dateValue1.includes('/')) {
            const parts = dateValue1.split('/');
            if (parts.length === 3) {
              // MM/dd/yyyy format
              dateSet = new Date(parseInt(parts[2]), parseInt(parts[0]) - 1, parseInt(parts[1]));
            } else {
              dateSet = new Date(dateValue1);
            }
          } else {
            dateSet = new Date(dateValue1);
          }
          
          console.log('Tab 1 - Parsed date:', dateSet);
          
          if (!isNaN(dateSet.getTime())) {
            const year = dateSet.getFullYear();
            const month = (dateSet.getMonth() + 1).toString().padStart(2, '0');
            const day = dateSet.getDate().toString().padStart(2, '0');
            this.selectedTabCData.DATE_OF_ACQUISITION = `${year}-${month}-${day}`;
            console.log('Tab 1 - Final date string:', this.selectedTabCData.DATE_OF_ACQUISITION);
          } else {
            console.log('Tab 1 - Could not parse date!');
          }
        } else {
          console.log('Tab 1 - DATE_OF_ACQUISITION is empty or null!');
        }

        if (item.COUNTRY) {
          this.selectedTabCData.COUNTRYCODE = this.getCountryInfo(item.COUNTRY);
        }

        if (item.STATE) {
          this.selectedTabCData.STATEOBJ = this.getStateInfo(item.STATE);
        }

        this.selectedTabCDataCloned = _.cloneDeep(this.selectedTabCData);
        break;

      case '2':
        this.activeTab = 2;
        this.selectedTabName = 'Add new Disposition';
        this.selectedTabDData = { ...item };
        console.log('Tab 2 - Looking for DATE_OF_DISPOSITION in item');
        console.log('Tab 2 - item.DATE_OF_DISPOSITION value:', item.DATE_OF_DISPOSITION);
        console.log('Tab 2 - item.DATE_OF_DISPOSITION type:', typeof item.DATE_OF_DISPOSITION);

        // Convert date to YYYY-MM-DD string format for HTML date input
        const dateValue2 = item.DATE_OF_DISPOSITION;
        if (dateValue2 && dateValue2 !== '' && dateValue2 !== 'null') {
          console.log('Tab 2 - Processing date:', dateValue2);
          let dateSet: Date;
          
          if (typeof dateValue2 === 'string' && dateValue2.includes('/')) {
            const parts = dateValue2.split('/');
            if (parts.length === 3) {
              dateSet = new Date(parseInt(parts[2]), parseInt(parts[0]) - 1, parseInt(parts[1]));
            } else {
              dateSet = new Date(dateValue2);
            }
          } else {
            dateSet = new Date(dateValue2);
          }
          
          console.log('Tab 2 - Parsed date:', dateSet);
          
          if (!isNaN(dateSet.getTime())) {
            const year = dateSet.getFullYear();
            const month = (dateSet.getMonth() + 1).toString().padStart(2, '0');
            const day = dateSet.getDate().toString().padStart(2, '0');
            this.selectedTabDData.DATE_OF_DISPOSITION = `${year}-${month}-${day}`;
            console.log('Tab 2 - Final date string:', this.selectedTabDData.DATE_OF_DISPOSITION);
          } else {
            console.log('Tab 2 - Could not parse date!');
          }
        } else {
          console.log('Tab 2 - DATE_OF_DISPOSITION is empty or null!');
        }

        if (item.COUNTRY) {
          this.selectedTabDData.COUNTRYCODE = this.getCountryInfo(item.COUNTRY);
        }

        if (item.STATE) {
          this.selectedTabDData.STATEOBJ = this.getStateInfo(item.STATE);
        }

        this.selectedTabDDataCloned = _.cloneDeep(this.selectedTabDData);
        break;

      case '3':
        this.activeTab = 3;
        this.selectedTabName = 'Add new Change in Proportional Interest';
        this.selectedTabEData = { ...item };
        console.log('Tab 3 - Looking for DATE_OF_CHANGE in item');
        console.log('Tab 3 - item.DATE_OF_CHANGE value:', item.DATE_OF_CHANGE);
        console.log('Tab 3 - item.DATE_OF_CHANGE type:', typeof item.DATE_OF_CHANGE);

        // Convert date to YYYY-MM-DD string format for HTML date input
        const dateValue3 = item.DATE_OF_CHANGE;
        if (dateValue3 && dateValue3 !== '' && dateValue3 !== 'null') {
          console.log('Tab 3 - Processing date:', dateValue3);
          let dateSet: Date;
          
          if (typeof dateValue3 === 'string' && dateValue3.includes('/')) {
            const parts = dateValue3.split('/');
            if (parts.length === 3) {
              dateSet = new Date(parseInt(parts[2]), parseInt(parts[0]) - 1, parseInt(parts[1]));
            } else {
              dateSet = new Date(dateValue3);
            }
          } else {
            dateSet = new Date(dateValue3);
          }
          
          console.log('Tab 3 - Parsed date:', dateSet);
          
          if (!isNaN(dateSet.getTime())) {
            const year = dateSet.getFullYear();
            const month = (dateSet.getMonth() + 1).toString().padStart(2, '0');
            const day = dateSet.getDate().toString().padStart(2, '0');
            this.selectedTabEData.DATE_OF_CHANGE = `${year}-${month}-${day}`;
            console.log('Tab 3 - Final date string:', this.selectedTabEData.DATE_OF_CHANGE);
          } else {
            console.log('Tab 3 - Could not parse date!');
          }
        } else {
          console.log('Tab 3 - DATE_OF_CHANGE is empty or null!');
        }

        this.selectedTabEDataCloned = _.cloneDeep(this.selectedTabEData);
        break;

      case '4':
        this.activeTab = 4;
        this.selectedTabName = 'Add new Supplemental Information';
        this.selectedTabFData = { ...item };
        this.selectedTabFDataCloned = _.cloneDeep(this.selectedTabFData);
        break;
    }
  }

  deleteSchedule(item: any) {
    const message = 'Schedule has been deleted';
    const json_arrOBJ: any[] = [];

    this.schedulePDetails.filter((e: any) =>
      e.occurrence === item.occurrence && e.i?.line_no == item.LINE_NO
    ).forEach((e: any) => {
      json_arrOBJ.push([{
        occurence: e.occurrence,
        tax_year: this.globalService.tax_year,
        trans_type_key: e.trans_type_key,
        trans_dtls_key: e.trans_details_key,
        trans_status: 'A',
        line_no: item.LINE_NO
      }]);
    });

    const scheduleDetails = { addrows: [], editrows: [], removerows: json_arrOBJ };
    const scheduleSettings = [{
      tax_year: this.globalService.tax_year,
      scenario: this.globalService.scenario,
      jcd_key: 250
    }];

    this.crudLoading = true;

    this.schedulePService.saveScheduleP(
      this.GENERAL_CONFIG.base_url,
      scheduleSettings,
      scheduleDetails,
      this.globalService,
      this.filterParams
    ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (result: any) => {
        this.crudLoading = false;

        if (result.errorMessage && result.errorMessage !== 'null') {
          this.gtwSnackbarService.openSnackBar(result.errorMessage, 'gtw-snackbar--red');
        } else {
          this.gtwSnackbarService.openSnackBar(message, 'gtw-snackbar--green');
          this.loadDetails();
        }
      },
      (error: any) => {
        this.crudLoading = false;
        this.gtwSnackbarService.openSnackBar('Error occurred while deleting. Please try again.', 'gtw-snackbar--red');
      }
    );
  }

  getCountryInfo(countryCode: string): any {
    return this.countries.find((c: any) => c.COUNTRY_CODE === countryCode) || {};
  }

  getStateInfo(stateCode: string): any {
    return this.states.find((s: any) => s.CODE === stateCode) || {};
  }

  changeCountry(countryCode: string, tab: string) {
    if (tab === 'c') {
      this.selectedTabCData.COUNTRY = this.selectedTabCData.COUNTRYCODE?.COUNTRY_CODE || '';
    } else if (tab === 'd') {
      this.selectedTabDData.COUNTRY = this.selectedTabDData.COUNTRYCODE?.COUNTRY_CODE || '';
    }
  }

  changeState(stateObj: any, tab: string) {
    if (tab === 'c') {
      this.selectedTabCData.STATE = this.selectedTabCData.STATEOBJ?.CODE || '';
    } else if (tab === 'd') {
      this.selectedTabDData.STATE = this.selectedTabDData.STATEOBJ?.CODE || '';
    }
  }

  changeRadioButton(value: string, tab: string) {
    if (tab === 'c') {
      this.selectedTabCData.NAME_LINE_1 = '';
      this.selectedTabCData.NAME_LINE_2 = '';
    } else if (tab === 'd') {
      this.selectedTabDData.NAME_LINE_1 = '';
      this.selectedTabDData.NAME_LINE_2 = '';
    }
  }

  radioClicked(tab: string, newValue?: string) {
    
    if (tab === 'C') {
      // Use the new value from ngModelChange if provided
      const value = newValue !== undefined ? newValue : this.selectedTabCData.VALUE;
      
      if (value === 'APPLD FOR' || value === 'FOREIGNUS') {
        this.selectedTabCData.DISVALUE = null;
        this.selectedTabCData.IDENTIFYING_NO = value;
        this.selectedTabCData.VALUE = value;
      } else {
        this.selectedTabCData.VALUE = this.selectedTabCData.DISVALUE;
        this.selectedTabCData.IDENTIFYING_NO = this.selectedTabCData.DISVALUE;
      }
    } else if (tab === 'D') {
      const value = newValue !== undefined ? newValue : this.selectedTabDData.VALUE;
      
      if (value === 'APPLD FOR' || value === 'FOREIGNUS') {
        this.selectedTabDData.DISVALUE = null;
        this.selectedTabDData.IDENTIFYING_NO = value;
        this.selectedTabDData.VALUE = value;
      } else {
        this.selectedTabDData.VALUE = this.selectedTabDData.DISVALUE;
        this.selectedTabDData.IDENTIFYING_NO = this.selectedTabDData.DISVALUE;
      }
    }
    
    this.cdr.detectChanges();
  }

  uncheckedRadio(tab: string) {
    if (tab === 'C') {
      if (this.selectedTabCData.DISVALUE != null) {
        this.selectedTabCData.IDENTIFYING_NO = this.selectedTabCData.VALUE = this.selectedTabCData.DISVALUE;
      } else {
        this.selectedTabCData.IDENTIFYING_NO = '';
      }
    } else if (tab === 'D') {
      if (this.selectedTabDData.DISVALUE != null) {
        this.selectedTabDData.IDENTIFYING_NO = this.selectedTabDData.VALUE = this.selectedTabDData.DISVALUE;
      } else {
        this.selectedTabDData.IDENTIFYING_NO = '';
      }
    }
  }

  formatDate(tab: number) {
    const start_date = parseAsLocalDate(this.rowData.TAX_YEAR_BEGIN);
    const end_date = parseAsLocalDate(this.rowData.TAX_YEAR_END);

    if (tab === 1) {
      const dateInputData = this.selectedTabCData.DATE_OF_ACQUISITION;
      this.date_flag_acquisition = !dateInputData;

      if (dateInputData) {
        const selectedDate = parseAsLocalDate(dateInputData);
        if (selectedDate && start_date && end_date && (selectedDate < start_date || selectedDate > end_date)) {
          this.date_range_acquisition = true;
        } else {
          this.date_range_acquisition = false;
          this.date_flag_acquisition = false;
        }
      }
    } else if (tab === 2) {
      const dateInputData = this.selectedTabDData.DATE_OF_DISPOSITION;
      this.date_flag_disposition = !dateInputData;

      if (dateInputData) {
        const selectedDate = parseAsLocalDate(dateInputData);
        if (selectedDate && start_date && end_date && (selectedDate < start_date || selectedDate > end_date)) {
          this.date_range_disposition = true;
        } else {
          this.date_flag_disposition = false;
          this.date_range_disposition = false;
        }
      }
    } else if (tab === 3) {
      const dateInputData = this.selectedTabEData.DATE_OF_CHANGE;
      this.date_flag_change = !dateInputData;

      if (dateInputData) {
        const selectedDate = parseAsLocalDate(dateInputData);
        if (selectedDate && start_date && end_date && (selectedDate < start_date || selectedDate > end_date)) {
          this.date_range_change = true;
        } else {
          this.date_flag_change = false;
          this.date_range_change = false;
        }
      }
    }
  }

  changeDescription(value: string) {
    this.desc_of_change = !value;
  }

  // Validate percentage (0-100%)
  validatePercentage(value: string, field: string) {
    const pattern = /^(0*100(\.0*)?|0*\d{0,2}(\.\d*)?)$/;
    const isValid = !value || pattern.test(value);
    
    switch (field) {
      case 'percent_before_acquisition':
        this.percent_before_acquisition_invalid = !isValid;
        break;
      case 'percent_after_acquisition':
        this.percent_after_acquisition_invalid = !isValid;
        break;
      case 'percent_before_disposition':
        this.percent_before_disposition_invalid = !isValid;
        break;
      case 'percent_after_disposition':
        this.percent_after_disposition_invalid = !isValid;
        break;
      case 'percent_before_change':
        this.percent_before_change_invalid = !isValid;
        break;
      case 'percent_after_change':
        this.percent_after_change_invalid = !isValid;
        break;
    }
  }

  // Validate zip code (numbers only for US)
  validateZipCode(value: string, tab: string) {
    const pattern = /^[0-9]*$/;
    const isValid = !value || pattern.test(value);
    
    if (tab === 'c') {
      this.zip_invalid_c = !isValid;
    } else if (tab === 'd') {
      this.zip_invalid_d = !isValid;
    }
  }

  reset() {
    switch (this.activeTab) {
      case 1:
        if (this.editFlag) {
          this.selectedTabCData = _.cloneDeep(this.selectedTabCDataCloned);
        } else {
          this.selectedTabCData = {};
          this.selectedTabCData.NAME_OF_PERSON_OR_BUSINESS = 'B';
          this.selectedTabCData.PERCENT_OF_INTEREST_BEFORE_ACQUISITION = null;
          this.selectedTabCData.PERCENT_OF_INTEREST_AFTER_ACQUISITION = null;
        }
        break;
      case 2:
        if (this.editFlag) {
          this.selectedTabDData = _.cloneDeep(this.selectedTabDDataCloned);
        } else {
          this.selectedTabDData = {};
          this.selectedTabDData.NAME_OF_PERSON_OR_BUSINESS = 'B';
          this.selectedTabDData.PERCENT_OF_INTEREST_BEFORE_DISPOSITION = null;
          this.selectedTabDData.PERCENT_OF_INTEREST_AFTER_DISPOSITION = null;
        }
        break;
      case 3:
        if (this.editFlag) {
          this.selectedTabEData = _.cloneDeep(this.selectedTabEDataCloned);
        } else {
          this.selectedTabEData = {};
          this.selectedTabEData.PERCENT_OF_INTEREST_BEFORE_CHANGE = null;
          this.selectedTabEData.PERCENT_OF_INTEREST_AFTER_CHANGE = null;
        }
        break;
      case 4:
        if (this.editFlag) {
          this.selectedTabFData = _.cloneDeep(this.selectedTabFDataCloned);
        } else {
          this.selectedTabFData = {};
        }
        break;
    }
  }

  save() {
    if (this.crudLoading) {
      this.gtwSnackbarService.openSnackBar('Please wait while we save this request', 'gtw-snackbar--yellow');
      return;
    }

    this.crudLoading = true;

    switch (this.activeTab) {
      case 1:
        this.saveAcquisition();
        break;
      case 2:
        this.saveDisposition();
        break;
      case 3:
        this.saveProportionalInterest();
        break;
      case 4:
        this.saveSupplementalInformation();
        break;
    }
  }

  /**
   * Format date for HTML input type="date" (requires YYYY-MM-DD)
   * Converts any date format to YYYY-MM-DD string
   */
  formatDateForInput(date: any): string {
    if (!date) return '';
    
    if (typeof date === 'string') {
      // Already in YYYY-MM-DD format
      if (/^\d{4}-\d{2}-\d{2}$/.test(date)) {
        return date;
      }
      // MM/DD/YYYY format - convert to YYYY-MM-DD
      if (/^\d{2}\/\d{2}\/\d{4}$/.test(date)) {
        const [month, day, year] = date.split('/');
        return `${year}-${month}-${day}`;
      }
      // M/D/YYYY format - convert to YYYY-MM-DD
      if (/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(date)) {
        const parts = date.split('/');
        const month = parts[0].padStart(2, '0');
        const day = parts[1].padStart(2, '0');
        const year = parts[2];
        return `${year}-${month}-${day}`;
      }
      // Try to parse as Date
      const parsedDate = new Date(date);
      if (!isNaN(parsedDate.getTime())) {
        const year = parsedDate.getFullYear();
        const month = (parsedDate.getMonth() + 1).toString().padStart(2, '0');
        const day = parsedDate.getDate().toString().padStart(2, '0');
        return `${year}-${month}-${day}`;
      }
      return '';
    }
    
    // It's a Date object
    if (date instanceof Date && !isNaN(date.getTime())) {
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');
      return `${year}-${month}-${day}`;
    }
    
    return '';
  }

  /**
   * Handle date input change - convert to YYYY-MM-DD for model
   */
  onDateInputChange(event: Event, tab: number) {
    const input = event.target as HTMLInputElement;
    const value = input.value; // This is already in YYYY-MM-DD from HTML date input
    
    switch (tab) {
      case 1:
        this.selectedTabCData.DATE_OF_ACQUISITION = value;
        break;
      case 2:
        this.selectedTabDData.DATE_OF_DISPOSITION = value;
        break;
      case 3:
        this.selectedTabEData.DATE_OF_CHANGE = value;
        break;
    }
    
    // Call validation
    this.formatDate(tab);
  }

  private formatDateForSave(date: Date | string): string {
    if (!date) return '';
    
    // If it's already a string in YYYY-MM-DD format (from HTML date input), convert to MM/DD/YYYY for API
    if (typeof date === 'string') {
      // Check if it's in YYYY-MM-DD format
      if (/^\d{4}-\d{2}-\d{2}$/.test(date)) {
        const [year, month, day] = date.split('-');
        return `${month}/${day}/${year}`;
      }
      // Check if it's already in MM/DD/YYYY format
      if (/^\d{2}\/\d{2}\/\d{4}$/.test(date)) {
        return date;
      }
      // Try to parse as Date
      const parsedDate = new Date(date);
      if (!isNaN(parsedDate.getTime())) {
        const month = (parsedDate.getMonth() + 1).toString().padStart(2, '0');
        const day = parsedDate.getDate().toString().padStart(2, '0');
        const year = parsedDate.getFullYear();
        return `${month}/${day}/${year}`;
      }
      return '';
    }
    
    // It's a Date object
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
  }

  saveAcquisition() {
    // Validate
    if (this.date_range_acquisition || !this.selectedTabCData.DATE_OF_ACQUISITION) {
      this.date_flag_acquisition = !this.selectedTabCData.DATE_OF_ACQUISITION;
      this.crudLoading = false;
      this.gtwSnackbarService.openSnackBar('Please fill out required fields.', 'gtw-snackbar--red');
      return;
    }

    this.date_flag_acquisition = false;
    this.date_range_acquisition = false;

    const scheduleSettings = [{
      tax_year: this.globalService.tax_year,
      scenario: this.globalService.scenario,
      jcd_key: 250
    }];

    const trans_type_key = this.acquistionArray.length > 0 ? this.acquistionArray[0].trans_type_key : null;
    const currentOccurence = this.selectedTabCData.occurrence;
    const editRow: any[] = [];

    // Format date
    const dateFormatted = this.formatDateForSave(this.selectedTabCData.DATE_OF_ACQUISITION);
    this.selectedTabCData.DATE_OF_ACQUISITION = dateFormatted;
    
    if (this.selectedTabCData.IDENTIFYING_NO) {
      // Only remove dash if it's an EIN, not if it's 'APPLD FOR' or 'FOREIGNUS'
      if (this.selectedTabCData.IDENTIFYING_NO !== 'APPLD FOR' && 
          this.selectedTabCData.IDENTIFYING_NO !== 'FOREIGNUS') {
        this.selectedTabCData.IDENTIFYING_NO = this.selectedTabCData.IDENTIFYING_NO.replace('-', '');
      }
    }

    // Build attribute mapping for US/non-US addresses
    const mping: any = {
      '8865_P_STOCK_ACQUISITION_F_ADDR_1': 'ADDRESS_LINE_1',
      '8865_P_STOCK_ACQUISITION_F_ADDR_2': 'ADDRESS_LINE_2',
      '8865_P_STOCK_ACQUISITION_F_CITY': 'CITY',
      '8865_P_STOCK_ACQUISITION_F_STATE': 'STATE',
      '8865_P_STOCK_ACQUISITION_F_ZIP': 'ZIP_OR_POSTAL_CODE',
      'ZIP_OR_POSTAL_CODE': '8865_P_STOCK_ACQUISITION_F_ZIP',
      'STATE': '8865_P_STOCK_ACQUISITION_F_STATE',
      'CITY': '8865_P_STOCK_ACQUISITION_F_CITY',
      'ADDRESS_LINE_2': '8865_P_STOCK_ACQUISITION_F_ADDR_2',
      'ADDRESS_LINE_1': '8865_P_STOCK_ACQUISITION_F_ADDR_1'
    };

    for (let i = 0; i < this.stockAcquisitionAttrib.length; i++) {
      const attrName = this.stockAcquisitionAttrib[i].attrib_name;

      // Skip non-US fields for US country
      if (this.selectedTabCData.COUNTRYCODE?.COUNTRY_CODE !== 'US' &&
          ['ADDRESS_LINE_1', 'ADDRESS_LINE_2', 'CITY', 'STATE', 'ZIP_OR_POSTAL_CODE'].includes(attrName)) {
        continue;
      }

      // Skip US fields for non-US country
      if (this.selectedTabCData.COUNTRYCODE?.COUNTRY_CODE === 'US' &&
          attrName.indexOf('8865_P_STOCK_ACQUISITION_F') > -1) {
        continue;
      }

      let currentTransDetailsKey = null;
      if (this.editFlag) {
        const found = this.schedulePDetails.find((e: any) =>
          e.line_attrib_key == this.stockAcquisitionAttrib[i].line_attrib_key &&
          e.occurrence == currentOccurence
        );
        currentTransDetailsKey = found?.trans_details_key || null;

        // Try mapped key if not found
        if (!currentTransDetailsKey && mping[attrName]) {
          const mappedAttr = this.stockAcquisitionAttrib.find((a: any) => a.attrib_name === mping[attrName]);
          if (mappedAttr) {
            const foundMapped = this.schedulePDetails.find((e: any) =>
              e.line_attrib_key == mappedAttr.line_attrib_key &&
              e.occurrence == currentOccurence
            );
            currentTransDetailsKey = foundMapped?.trans_details_key || null;
          }
        }
      }

      const tempObj = [{
        tax_year: this.globalService.tax_year,
        trans_type_key: trans_type_key,
        combination_key: this.rowData.HO_COMBINATION_KEY,
        group_obj_key: this.rowData.GROUP_OBJ_KEY,
        form_key: this.acquistionArray[0]?.form_key,
        line_no: 1,
        occurence: this.editFlag ? currentOccurence : null,
        line_attrib_key: this.stockAcquisitionAttrib[i].line_attrib_key,
        Attribute_Name: attrName,
        Attribute_Value: this.selectedTabCData[attrName],
        trans_dtls_key: this.editFlag ? currentTransDetailsKey : null,
        trans_status: 'A'
      }];

      editRow.push(tempObj);
    }

    const scheduleDetails = { addrows: [], editrows: editRow, removerows: [] };
    const message = 'New Stock Acquisition is saved';

    this.schedulePService.saveScheduleP(
      this.GENERAL_CONFIG.base_url,
      scheduleSettings,
      scheduleDetails,
      this.globalService,
      this.filterParams
    ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (result: any) => {
        this.crudLoading = false;

        if (result.errorMessage && result.errorMessage !== 'null') {
          this.gtwSnackbarService.openSnackBar(result.errorMessage, 'gtw-snackbar--red');
        } else {
          this.gtwSnackbarService.openSnackBar(message, 'gtw-snackbar--green');
          this.requestGridUpdate.emit('refresh');
          // After successful save, navigate to first tab to prevent duplicate saves
          this.clearTabData(1);
          this.onTabChange(0);
        }
      },
      (error: any) => {
        this.crudLoading = false;
        this.gtwSnackbarService.openSnackBar('Error occurred while saving. Please try again.', 'gtw-snackbar--red');
      }
    );
  }

  saveDisposition() {
    // Validate
    if (this.date_range_disposition || !this.selectedTabDData.DATE_OF_DISPOSITION) {
      this.date_flag_disposition = !this.selectedTabDData.DATE_OF_DISPOSITION;
      this.crudLoading = false;
      this.gtwSnackbarService.openSnackBar('Please fill out required fields.', 'gtw-snackbar--red');
      return;
    }

    this.date_flag_disposition = false;
    this.date_range_disposition = false;

    const scheduleSettings = [{
      tax_year: this.globalService.tax_year,
      scenario: this.globalService.scenario,
      jcd_key: 250
    }];

    const trans_type_key = this.dispositionArray.length > 0 ? this.dispositionArray[0].trans_type_key : null;
    const currentOccurence = this.selectedTabDData.occurrence;
    const editRow: any[] = [];

    // Format date
    const dateFormatted = this.formatDateForSave(this.selectedTabDData.DATE_OF_DISPOSITION);
    this.selectedTabDData.DATE_OF_DISPOSITION = dateFormatted;

    
    if (this.selectedTabDData.IDENTIFYING_NO) {
      // Only remove dash if it's an EIN, not if it's 'APPLD FOR' or 'FOREIGNUS'
      if (this.selectedTabDData.IDENTIFYING_NO !== 'APPLD FOR' && 
          this.selectedTabDData.IDENTIFYING_NO !== 'FOREIGNUS') {
        this.selectedTabDData.IDENTIFYING_NO = this.selectedTabDData.IDENTIFYING_NO.replace('-', '');
      }
    }

    const mping: any = {
      '8865_P_STOCK_DISPOSITION_F_ADDR_1': 'ADDRESS_LINE_1',
      '8865_P_STOCK_DISPOSITION_F_ADDR_2': 'ADDRESS_LINE_2',
      '8865_P_STOCK_DISPOSITION_F_CITY': 'CITY',
      '8865_P_STOCK_DISPOSITION_F_STATE': 'STATE',
      '8865_P_STOCK_DISPOSITION_F_ZIP': 'ZIP_OR_POSTAL_CODE',
      'ZIP_OR_POSTAL_CODE': '8865_P_STOCK_DISPOSITION_F_ZIP',
      'STATE': '8865_P_STOCK_DISPOSITION_F_STATE',
      'CITY': '8865_P_STOCK_DISPOSITION_F_CITY',
      'ADDRESS_LINE_2': '8865_P_STOCK_DISPOSITION_F_ADDR_2',
      'ADDRESS_LINE_1': '8865_P_STOCK_DISPOSITION_F_ADDR_1'
    };

    for (let i = 0; i < this.stockDispositionAttrib.length; i++) {
      const attrName = this.stockDispositionAttrib[i].attrib_name;

      if (this.selectedTabDData.COUNTRYCODE?.COUNTRY_CODE !== 'US' &&
          ['ADDRESS_LINE_1', 'ADDRESS_LINE_2', 'CITY', 'STATE', 'ZIP_OR_POSTAL_CODE'].includes(attrName)) {
        continue;
      }

      if (this.selectedTabDData.COUNTRYCODE?.COUNTRY_CODE === 'US' &&
          attrName.indexOf('8865_P_STOCK_DISPOSITION_F') > -1) {
        continue;
      }

      let currentTransDetailsKey = null;
      if (this.editFlag) {
        const found = this.schedulePDetails.find((e: any) =>
          e.line_attrib_key == this.stockDispositionAttrib[i].line_attrib_key &&
          e.occurrence == currentOccurence
        );
        currentTransDetailsKey = found?.trans_details_key || null;

        if (!currentTransDetailsKey && mping[attrName]) {
          const mappedAttr = this.stockDispositionAttrib.find((a: any) => a.attrib_name === mping[attrName]);
          if (mappedAttr) {
            const foundMapped = this.schedulePDetails.find((e: any) =>
              e.line_attrib_key == mappedAttr.line_attrib_key &&
              e.occurrence == currentOccurence
            );
            currentTransDetailsKey = foundMapped?.trans_details_key || null;
          }
        }
      }

      const tempObj = [{
        tax_year: this.globalService.tax_year,
        trans_type_key: trans_type_key,
        combination_key: this.rowData.HO_COMBINATION_KEY,
        group_obj_key: this.rowData.GROUP_OBJ_KEY,
        form_key: this.dispositionArray[0]?.form_key,
        line_no: 2,
        occurence: this.editFlag ? currentOccurence : null,
        line_attrib_key: this.stockDispositionAttrib[i].line_attrib_key,
        Attribute_Name: attrName,
        Attribute_Value: this.selectedTabDData[attrName],
        trans_dtls_key: this.editFlag ? currentTransDetailsKey : null,
        trans_status: 'A'
      }];

      editRow.push(tempObj);
    }

    const scheduleDetails = { addrows: [], editrows: editRow, removerows: [] };
    const message = 'New Stock Disposition is saved';

    this.schedulePService.saveScheduleP(
      this.GENERAL_CONFIG.base_url,
      scheduleSettings,
      scheduleDetails,
      this.globalService,
      this.filterParams
    ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (result: any) => {
        this.crudLoading = false;

        if (result.errorMessage && result.errorMessage !== 'null') {
          this.gtwSnackbarService.openSnackBar(result.errorMessage, 'gtw-snackbar--red');
        } else {
          this.gtwSnackbarService.openSnackBar(message, 'gtw-snackbar--green');
          this.requestGridUpdate.emit('refresh');
          // After successful save, navigate to first tab to prevent duplicate saves
          this.clearTabData(2);
          this.onTabChange(0);
        }
      },
      (error: any) => {
        this.crudLoading = false;
        this.gtwSnackbarService.openSnackBar('Error occurred while saving. Please try again.', 'gtw-snackbar--red');
      }
    );
  }

  saveProportionalInterest() {
    // Validate
    this.desc_of_change = !this.selectedTabEData.DESCRIPTION_OF_CHANGE;
    this.date_flag_change = !this.selectedTabEData.DATE_OF_CHANGE;

    if (this.desc_of_change || this.date_range_change || this.date_flag_change) {
      this.crudLoading = false;
      this.gtwSnackbarService.openSnackBar('Please fill out required fields.', 'gtw-snackbar--red');
      return;
    }

    this.date_flag_change = false;
    this.date_range_change = false;
    this.desc_of_change = false;

    const scheduleSettings = [{
      tax_year: this.globalService.tax_year,
      scenario: this.globalService.scenario,
      jcd_key: 250
    }];

    const trans_type_key = this.proportionalInterestArray.length > 0 ? this.proportionalInterestArray[0].trans_type_key : null;
    const currentOccurence = this.selectedTabEData.occurrence;
    const editRow: any[] = [];

    // Format date
    const dateFormatted = this.formatDateForSave(this.selectedTabEData.DATE_OF_CHANGE);
    this.selectedTabEData.DATE_OF_CHANGE = dateFormatted;

    for (let i = 0; i < this.stockProportionalAttrib.length; i++) {
      let currentTransDetailsKey = null;
      if (this.editFlag) {
        const found = this.schedulePDetails.find((e: any) =>
          e.line_attrib_key == this.stockProportionalAttrib[i].line_attrib_key &&
          e.occurrence == currentOccurence
        );
        currentTransDetailsKey = found?.trans_details_key || null;
      }

      const tempObj = [{
        tax_year: this.globalService.tax_year,
        trans_type_key: trans_type_key,
        combination_key: this.rowData.HO_COMBINATION_KEY,
        group_obj_key: this.rowData.GROUP_OBJ_KEY,
        form_key: this.proportionalInterestArray[0]?.form_key,
        line_no: 3,
        occurence: this.editFlag ? currentOccurence : null,
        line_attrib_key: this.stockProportionalAttrib[i].line_attrib_key,
        Attribute_Name: this.stockProportionalAttrib[i].attrib_name,
        Attribute_Value: this.selectedTabEData[this.stockProportionalAttrib[i].attrib_name],
        trans_dtls_key: this.editFlag ? currentTransDetailsKey : null,
        trans_status: 'A'
      }];

      editRow.push(tempObj);
    }

    const scheduleDetails = { addrows: [], editrows: editRow, removerows: [] };
    const message = 'Change in Proportional Interest is saved';

    this.schedulePService.saveScheduleP(
      this.GENERAL_CONFIG.base_url,
      scheduleSettings,
      scheduleDetails,
      this.globalService,
      this.filterParams
    ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (result: any) => {
        this.crudLoading = false;

        if (result.errorMessage && result.errorMessage !== 'null') {
          this.gtwSnackbarService.openSnackBar(result.errorMessage, 'gtw-snackbar--red');
        } else {
          this.gtwSnackbarService.openSnackBar(message, 'gtw-snackbar--green');
          this.requestGridUpdate.emit('refresh');
          // After successful save, navigate to first tab to prevent duplicate saves
          this.clearTabData(3);
          this.onTabChange(0);
        }
      },
      (error: any) => {
        this.crudLoading = false;
        this.gtwSnackbarService.openSnackBar('Error occurred while saving. Please try again.', 'gtw-snackbar--red');
      }
    );
  }

  saveSupplementalInformation() {
    const scheduleSettings = [{
      tax_year: this.globalService.tax_year,
      scenario: this.globalService.scenario,
      jcd_key: 250
    }];

    const trans_type_key = this.supplementalArray.length > 0 ? this.supplementalArray[0].trans_type_key : null;
    const currentOccurence = (!this.supplementalObj.length || !this.supplementalObj[0]?.occurrence)
      ? null : this.supplementalObj[0].occurrence;
    const editRow: any[] = [];

    for (let i = 0; i < this.stocksupplementalAttrib.length; i++) {
      let currentTransDetailsKey = null;
      if (this.supplementalObj.length > 0) {
        const found = this.schedulePDetails.find((e: any) =>
          e.line_attrib_key == this.stocksupplementalAttrib[i].line_attrib_key &&
          e.occurrence == currentOccurence
        );
        currentTransDetailsKey = found?.trans_details_key || null;
      }

      const tempObj = [{
        tax_year: this.globalService.tax_year,
        trans_type_key: trans_type_key,
        combination_key: this.rowData.HO_COMBINATION_KEY,
        group_obj_key: this.rowData.GROUP_OBJ_KEY,
        form_key: this.supplementalArray[0]?.form_key,
        line_no: 4,
        occurence: currentOccurence,
        line_attrib_key: this.stocksupplementalAttrib[i].line_attrib_key,
        Attribute_Name: this.stocksupplementalAttrib[i].attrib_name,
        Attribute_Value: this.selectedTabFData[this.stocksupplementalAttrib[i].attrib_name],
        trans_dtls_key: currentTransDetailsKey,
        trans_status: 'A'
      }];

      editRow.push(tempObj);
    }

    const scheduleDetails = { addrows: [], editrows: editRow, removerows: [] };
    const message = 'New Supplemental information is saved';

    this.schedulePService.saveScheduleP(
      this.GENERAL_CONFIG.base_url,
      scheduleSettings,
      scheduleDetails,
      this.globalService,
      this.filterParams
    ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (result: any) => {
        this.crudLoading = false;

        if (result.errorMessage && result.errorMessage !== 'null') {
          this.gtwSnackbarService.openSnackBar(result.errorMessage, 'gtw-snackbar--red');
        } else {
          this.gtwSnackbarService.openSnackBar(message, 'gtw-snackbar--green');
          this.requestGridUpdate.emit('refresh');
          // After successful save, navigate to first tab to prevent duplicate saves
          this.clearTabData(4);
          this.onTabChange(0);
        }
      },
      (error: any) => {
        this.crudLoading = false;
        this.gtwSnackbarService.openSnackBar('Error occurred while saving. Please try again.', 'gtw-snackbar--red');
      }
    );
  }

  cancel() {
    this.requestGridUpdate.emit('cancel');
  }

  // Helper for template - check if current tab is not first tab
  isActionTab(): boolean {
    return this.activeTab !== 0;
  }

  // Format display address based on country
  getDisplayAddress(item: any, field: string): string {
    const isUS = item.COUNTRY === 'US';
    const prefix = field === 'ACQUISITION' ? '8865_P_STOCK_ACQUISITION_F_' : '8865_P_STOCK_DISPOSITION_F_';

    switch (field) {
      case 'ADDRESS_LINE_1':
        return isUS ? item.ADDRESS_LINE_1 : item[prefix + 'ADDR_1'];
      case 'ADDRESS_LINE_2':
        return isUS ? item.ADDRESS_LINE_2 : item[prefix + 'ADDR_2'];
      case 'CITY':
        return isUS ? item.CITY : item[prefix + 'CITY'];
      case 'STATE':
        return item.STATE?.CODE || (isUS ? item.STATE : item[prefix + 'STATE']);
      case 'ZIP':
        return isUS ? item.ZIP_OR_POSTAL_CODE : item[prefix + 'ZIP'];
      default:
        return '';
    }
  }

  // Check if country is US for conditional display
  isUSCountry(tab: string): boolean {
    if (tab === 'c') {
      return this.selectedTabCData.COUNTRYCODE?.COUNTRY_CODE === 'US';
    } else if (tab === 'd') {
      return this.selectedTabDData.COUNTRYCODE?.COUNTRY_CODE === 'US';
    }
    return false;
  }

  // Percentage pattern validation
  isValidPercentage(value: string): boolean {
    if (!value) return true;
    const pattern = /^(0*100{1,1}\.?((?<=\.)0*)?%?$)|(^0*\d{0,2}\.?((?<=\.)\d*)?%?)$/;
    return pattern.test(value);
  }
}



